export default {
    data() {
        return {
            activeEl: null,
            activeCategory: null,
            isDesktop: null,
            hideHeader: false,
            headerAtTop: true,
            lastScrollPosition: 0
        };
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        'activeEl': 'handleActiveElWatch',
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    },
    methods: {
        isActiveEl(el) {
            return this.activeEl === el;
        },
        setActiveEl(clickedEl, toggle = true) {
            this.activeEl = this.activeEl === clickedEl && toggle ? null : clickedEl;
        },
        removeActiveEl() {
            this.activeEl = null;
        },
        setActiveCategory(category) {
            this.activeCategory = category;
        },
        handleActiveElWatch(el) {
            if (['search', 'cartModal', 'categoriesMenu'].includes(el)) {
                this.$refs.header.scrollIntoView({behavior: "smooth"});
            }

            if(el !== 'categoriesMenu') {
                this.activeCategory = null;
            }

            // const body = document.body;
            // el !== null ? body.classList.add('scroll-disabled') : body.classList.remove('scroll-disabled');
        },
        onScroll() {
            const pathname = window.location.pathname;

            if (!this.$refs.header || pathname.includes('/chat')) return;

            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScrollPosition < 0) return;

            const heightWithAboveHeaderContent = this.$refs.header.offsetHeight + this.$refs.aboveHeaderContent.offsetHeight;

            if (currentScrollPosition <= heightWithAboveHeaderContent) {
                this.hideHeader = false;
                this.headerAtTop = true;
                return;
            } else {
                this.headerAtTop = false;
            }

            if (this.activeEl) return;

            // const differenceFromLastScroll = Math.abs(currentScrollPosition - this.lastScrollPosition);
            // if (differenceFromLastScroll < this.$refs.header.offsetHeight) return;

            this.hideHeader = currentScrollPosition > this.lastScrollPosition;
            this.lastScrollPosition = currentScrollPosition;
        },
        handleResize() {
            const isDesktop = window.innerWidth > 600;
            this.isDesktop = isDesktop;

            if (isDesktop) {
                this.activeCategory = null;
            }
        },
    },
};
